module.exports = __webpack_public_path__ + "static/media/easyweather.firebaseapp.com_(Laptop with MDPI screen).6675fa72.png";